import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import './FAQ.css';

const FAQ = ({ language }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = {
    en: {
      title: 'Frequently Asked Questions',
      subtitle: 'Everything you need to know about our cleaning services',
      items: [
        {
          question: 'What areas of Connecticut do you serve?',
          answer: 'We proudly serve Waterbury, Hartford, New Haven, Meriden, Bridgeport, Danbury, and all surrounding areas in Connecticut. If you\'re not sure if we service your area, give us a call at (475) 343-7298 and we\'ll be happy to help!'
        },
        {
          question: 'How much does cleaning service cost?',
          answer: 'Our pricing varies based on the size of your property, type of cleaning needed, and frequency of service. We offer free, no-obligation quotes! Contact us at (475) 343-7298 or fill out our form to get a personalized quote within 24 hours.'
        },
        {
          question: 'Are you insured and licensed?',
          answer: 'Yes! Brilliant Touch is fully insured and licensed. All our professional cleaners are thoroughly trained, background-checked, and insured for your complete peace of mind. Your property and belongings are in safe hands.'
        },
        {
          question: 'Do you offer same-day or emergency service?',
          answer: 'Yes, we offer 24/7 emergency cleaning services based on availability. Whether you need last-minute cleaning for an event or urgent post-construction cleanup, we\'re here to help. Call us at (475) 343-7298 to check availability.'
        },
        {
          question: 'Do you use eco-friendly products?',
          answer: 'Absolutely! We use premium eco-friendly cleaning products that are safe for children, pets, and the environment. We also offer 100% green cleaning options upon request. Your family\'s health is our priority.'
        },
        {
          question: 'What is included in a standard cleaning?',
          answer: 'Our standard cleaning includes dusting all surfaces, vacuuming and mopping floors, cleaning bathrooms (toilets, sinks, showers, mirrors), kitchen cleaning (counters, appliances, sink), trash removal, and more. Deep cleaning and custom services are also available.'
        },
        {
          question: 'Do I need to be home during the cleaning?',
          answer: 'No, you don\'t need to be home! Many of our clients provide us with access instructions and go about their day. We\'re trusted, professional, and fully insured. However, you\'re always welcome to be present if you prefer.'
        },
        {
          question: 'What if I\'m not satisfied with the cleaning?',
          answer: 'Your satisfaction is 100% guaranteed! If you\'re not completely happy with our service, let us know within 24 hours and we\'ll return to re-clean the areas of concern at no extra charge. Your happiness is our success.'
        }
      ]
    },
    es: {
      title: 'Preguntas Frecuentes',
      subtitle: 'Todo lo que necesitas saber sobre nuestros servicios de limpieza',
      items: [
        {
          question: '¿Qué áreas de Connecticut cubren?',
          answer: 'Con orgullo servimos Waterbury, Hartford, New Haven, Meriden, Bridgeport, Danbury y todas las áreas circundantes en Connecticut. Si no estás seguro si servimos tu área, llámanos al (475) 343-7298 y estaremos encantados de ayudarte.'
        },
        {
          question: '¿Cuánto cuesta el servicio de limpieza?',
          answer: 'Nuestros precios varían según el tamaño de tu propiedad, tipo de limpieza necesaria y frecuencia del servicio. ¡Ofrecemos cotizaciones gratuitas sin compromiso! Contáctanos al (475) 343-7298 o completa nuestro formulario para obtener una cotización personalizada en 24 horas.'
        },
        {
          question: '¿Están asegurados y tienen licencia?',
          answer: '¡Sí! Brilliant Touch está completamente asegurado y licenciado. Todos nuestros limpiadores profesionales están completamente capacitados, verificados y asegurados para tu completa tranquilidad. Tu propiedad y pertenencias están en manos seguras.'
        },
        {
          question: '¿Ofrecen servicio el mismo día o de emergencia?',
          answer: 'Sí, ofrecemos servicios de limpieza de emergencia 24/7 según disponibilidad. Ya sea que necesites limpieza de último minuto para un evento o limpieza urgente post-construcción, estamos aquí para ayudar. Llámanos al (475) 343-7298 para verificar disponibilidad.'
        },
        {
          question: '¿Usan productos eco-amigables?',
          answer: '¡Absolutamente! Usamos productos de limpieza premium eco-amigables que son seguros para niños, mascotas y el medio ambiente. También ofrecemos opciones de limpieza 100% verde bajo pedido. La salud de tu familia es nuestra prioridad.'
        },
        {
          question: '¿Qué incluye una limpieza estándar?',
          answer: 'Nuestra limpieza estándar incluye quitar polvo de todas las superficies, aspirar y trapear pisos, limpiar baños (inodoros, lavabos, duchas, espejos), limpieza de cocina (mostradores, electrodomésticos, fregadero), remoción de basura y más. También disponible limpieza profunda y servicios personalizados.'
        },
        {
          question: '¿Necesito estar en casa durante la limpieza?',
          answer: '¡No, no necesitas estar en casa! Muchos de nuestros clientes nos proporcionan instrucciones de acceso y continúan con su día. Somos confiables, profesionales y completamente asegurados. Sin embargo, siempre eres bienvenido a estar presente si lo prefieres.'
        },
        {
          question: '¿Qué pasa si no estoy satisfecho con la limpieza?',
          answer: '¡Tu satisfacción está 100% garantizada! Si no estás completamente feliz con nuestro servicio, avísanos dentro de 24 horas y regresaremos para re-limpiar las áreas de preocupación sin cargo adicional. Tu felicidad es nuestro éxito.'
        }
      ]
    }
  };

  const t = faqs[language];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="container">
        <div className="section-head">
          <h2>{t.title}</h2>
          <p>{t.subtitle}</p>
        </div>
        <div className="faq-list">
          {t.items.map((faq, index) => (
            <div key={index} className={`faq-item ${openIndex === index ? 'open' : ''}`}>
              <button
                className="faq-question"
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span>{faq.question}</span>
                {openIndex === index ? (
                  <ChevronUp size={24} />
                ) : (
                  <ChevronDown size={24} />
                )}
              </button>
              {openIndex === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
